module.exports = __webpack_public_path__ + "images/dee8f607a3c71e26041c9ad60c4581b02dc82f5fd0aec3569b3c6c9688ed9b8b.svg";